import { fromJS } from "immutable"

const initQahoData = fromJS({
  
})


const initFilterDataQaho= fromJS({
  invoiceNo:'',
  clientName:'',
  customerName:'',
  pageNo:1,
  pageSize:10,
})

export function qahoData(
  state = initQahoData,
  action
) {
  switch (action.type) {
    case "QAHO_FETCH_DATA_SUCCESS":
      return fromJS(action.dataQaho);
    default:
      return state;
  }
}


export function filterDataQaho(
  state = initFilterDataQaho,
  action
){
  switch (action.type) {
    case "FILTER_SET_INVOICE_NO_SUCCESS":
      return state.set('invoiceNo', action.invoiceNo)
    case "FILTER_SET_CLIENT_NAME_SUCCESS":
      return state.set('clientName', action.clientName)
    case "FILTER_SET_CUSTOMER_NAME_SUCCESS":
      return state.set('customerName', action.customerName)
    case "FILTER_SET_PAGE_NO_SUCCESS":
      return state.set('pageNo', action.pageNo)
    case "FILTER_SET_PAGE_SIZE_SUCCESS":
      return state.set('pageSize', action.pageSize)
    default:
      return state;
  }
 
}


export function approvalQahoDetail(
  state= fromJS([]),
  action
){
  switch (action.type) {
    case "APPROVAL_QAHO_DETAIL_FETCH":
      return fromJS(action.detail);
    default:
      return state;
  }
}


export function valueQahoData(state = fromJS([]), action) {
  switch (action.type) {
    case "VALUE_QAHO_DATA_SUCCESS":
      return fromJS(action.detail);
    default:
      return state;
  }
}

